import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import momentLocalizer from 'react-widgets-moment';
import store from './store';
import AppContainer from './containers/App';
import * as serviceWorker from './serviceWorker';
import { applyFavicon } from './favicon';

import './i18n';
momentLocalizer();
const VARIANT = (process.env.REACT_APP_BRAND || '').toLowerCase();
document.title = VARIANT === 'urclyrd' ? 'Urclyrd' : 'Podesubir';

applyFavicon();

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <AppContainer />
    </Router>
  </Provider>,
document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();;
console.log(1);
